import axios from "axios";

// http://127.0.0.1:8000/api/v1
// https://isit-api.bitsclan.com/api/v1

const api = axios.create({
  baseURL: "https://staging.isit.services/api/v1",
  // baseURL: "http://127.0.0.1:8000/api/v1",
  timeout: 10000,
});

api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("token");
    const language = localStorage.getItem("language") || "en";
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    config.headers["Accept-Language"] = language;
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
